export default "__VITE_ASSET__DdbrJW4J__"